import { Routes } from './types'
import config from '../common/config'
import { defaultRoutes } from './config'

// TODO: Generate these domains using the folder structure itself.
const _getMatcherDefaultDomainMap = (environment: string) => {
    switch (environment) {
        case 'development':
            return new Map<RegExp, string>([[/localhost/, 'localhost']])
        case 'staging':
            return new Map<RegExp, string>([
                [
                    /guest-website-frontend(-\w)?.*-proxy\.svc\.staging\.tfw\.io/,
                    'guest-website-frontend.svc.staging.tfw.io',
                ],
            ])
        default:
            return new Map<RegExp, string>([
                [/traum-ferienwohnungen\.de/, 'traum-ferienwohnungen.de'],
                [/traum-ferienwohnungen\.ch/, 'traum-ferienwohnungen.ch'],
                [/traum-ferienwohnungen\.at/, 'traum-ferienwohnungen.at'],
                [/vacation-apartments\.com/, 'vacation-apartments.com'],
                [/holiday-apartments\.co\.uk/, 'holiday-apartments.co.uk'],
            ])
    }
}

const _matcherDefaultDomainMap = _getMatcherDefaultDomainMap(config.environment)

const _getMatcherDomainPairs = (matcherDefaultDomainMap: Map<RegExp, string>) =>
    // Disable lint in next line as Map::values() returns an iterator which cannot be used with spread operator.
    /* eslint-disable-next-line unicorn/prefer-spread */
    Array.from(matcherDefaultDomainMap.entries())

const _matcherDomainPairs = _getMatcherDomainPairs(_matcherDefaultDomainMap)

export const isDomain = (tested: string) => _matcherDomainPairs.some(([matcher]) => matcher.test(tested))
export const getDomain = (tested: string) => _matcherDomainPairs.find(([matcher]) => matcher.test(tested))?.[1]

export const getRoutesFromDomain = (domain: string) => getRoutes(domain)

export const getRoutes = (domain: string): Promise<Routes> =>
    isDomain(domain)
        ? import(`./environment/${config.environment}/${getDomain(domain)}.json`).then(({ default: routes }) => routes)
        : new Promise(resolve => resolve(defaultRoutes))
